import { render, staticRenderFns } from "./AbsencesEditorStartEnd.vue?vue&type=template&id=4b16f666&scoped=true&lang=pug&"
import script from "./AbsencesEditorStartEnd.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditorStartEnd.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesEditorStartEnd.vue?vue&type=style&index=0&id=4b16f666&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16f666",
  null
  
)

export default component.exports